<button
  type="button"
  class="dab-button"
  [class.is-busy]="busy"
  [class.is-active]="active"
  [class.icon-right]="config.iconPosition === 'right'"
  [ngStyle]="buttonStyles"
  [attr.aria-busy]="busy"
  [disabled]="busy || disabled"
  [attr.aria-pressed]="config.action === 'filter' && config.filterToggle ? active : null"
  (click)="onClick()"
>
  <span class="dab-spinner" *ngIf="busy" aria-hidden="true"></span>
  <mat-icon *ngIf="showIcon && !busy" aria-hidden="true">{{ config.icon }}</mat-icon>
  <span class="dab-label">{{ config.label }}</span>
</button>

<!-- Hangs under the button, out of the layout: showing it never moves the button. -->
<small class="dab-message" *ngIf="shownMessage" [class.is-error]="messageKind === 'error'" role="status">{{ shownMessage }}</small>

<!-- Same popup as the Popup widget; its own trigger is hidden, this button opens it. -->
<app-dvm-popup
  *ngIf="hasEmbeddedPopup"
  [hideTrigger]="true"
  [data]="popupData"
  (navigateTo)="navigateTo.emit($event)"
></app-dvm-popup>
